import Link, { type LinkProps } from 'next/link';
import { type ComponentPropsWithoutRef, memo, type ReactNode } from 'react';

import { breadcrumbsButton } from './BreadcrumbsButton';

export type BreadcrumbsLinkProps = Omit<ComponentPropsWithoutRef<'a'>, keyof LinkProps | 'prefix'> &
  LinkProps & {
    prefix?: ReactNode;
    suffix?: ReactNode;
  };

export const BreadcrumbsLink = memo(
  ({ children, className, href, prefix, suffix, ...restOfProps }: BreadcrumbsLinkProps) => {
    return (
      <Link
        className={breadcrumbsButton({ class: className })}
        data-testid="BREADCRUMBS_LINK"
        href={href}
        {...restOfProps}
      >
        {!!prefix && <div className="shrink-0">{prefix}</div>}
        <div className="truncate">{children}</div>
        {!!suffix && <div className="shrink-0">{suffix}</div>}
      </Link>
    );
  },
);

BreadcrumbsLink.displayName = 'BreadcrumbsLink';
